import React, { useState, useEffect, useRef, useLayoutEffect } from "react";
import AppLayout from "../layouts/AppLayout.js";
import { useParams } from "react-router-dom";
import "./PublicProfile.css";
import PostDetailModal from "./PostDetailModal.js";
import axios from "axios";
import Post from "./Post.js";
import PostItem from "./PostItem.js";
import { timeAgo } from "../utils/timeAgo";   // âœ… RIGHT


function PublicProfile() {
  const { username } = useParams();
  const [publicUser, setPublicUser] = useState(null);
  const [posts, setPosts] = useState([]);
  const [selectedPost, setSelectedPost] = useState(null);
  const [showPostModal, setShowPostModal] = useState(false);

  const [isFollowing, setIsFollowing] = useState(false);
  const [followLoading, setFollowLoading] = useState(false);
  const [followerCount, setFollowerCount] = useState(0);
  const [followingCount, setFollowingCount] = useState(0);

  // âœ… For reply connector line
const originalRefs = useRef({});
const replyRefs = useRef({});
const [lineHeights, setLineHeights] = useState({});


  // âœ… New: Counts for each tab
  const [postCount, setPostCount] = useState(0);
  const [replyCount, setReplyCount] = useState(0);
  const [likeCount, setLikeCount] = useState(0);
  const [repostCount, setRepostCount] = useState(0);
  const [mediaCount, setMediaCount] = useState(0);

  const [showUserListModal, setShowUserListModal] = useState(false);
  const [userListType, setUserListType] = useState(""); // "followers" or "following"
  const [userList, setUserList] = useState([]);
  const [activeTab, setActiveTab] = useState("posts");

  const [dropdownOpen, setDropdownOpen] = useState(null);

  const openReplyDialog = (id) => { /* implement or reuse Profile logic */ };
  const handleDeletePost = (id) => { /* implement or reuse Profile logic */ };
  const reportPost = (id) => { /* implement or reuse Profile logic */ };



  // âœ… Toolbar filter state for PublicProfile
  const [publicTab, setPublicTab] = useState("posts");

  // âœ… PublicProfile filter state
  const [publicFilterType, setPublicFilterType] = useState("all");

  // âœ… Post groups for this profile
  const [publicPosts, setPublicPosts] = useState([]);
  const [publicLikedPosts, setPublicLikedPosts] = useState([]);
  const [publicUserReplies, setPublicUserReplies] = useState([]);
  const [publicUserReposts, setPublicUserReposts] = useState([]);

// âœ… Fetch posts, likes, reposts, replies for a PUBLIC user
const fetchPublicProfilePosts = async (username) => {
  try {
    // ðŸ”¹ All posts
    const response = await fetch(`${process.env.REACT_APP_API_URL}/posts`);
    if (!response.ok) throw new Error("Failed to fetch posts.");
    let allPosts = await response.json();

    // âœ… User's own posts
const userPosts = allPosts
  .filter(post => post.username === username)
  .map(post => ({
    ...post,
    repliesCount: post.repliesCount || 0,
    repostsCount: post.repostsCount || 0,
    thumbnail: post.thumbnail?.startsWith("http")
      ? post.thumbnail
      : `${process.env.REACT_APP_API_URL}${post.thumbnail || "/images/default-thumbnail.jpg"}`,
    media_url: post.media_url
      ? (post.media_url.startsWith("http")
          ? post.media_url
          : post.media_url.startsWith("/backend/")
            ? `${process.env.REACT_APP_API_URL}${post.media_url.replace("/backend", "")}`
            : `${process.env.REACT_APP_API_URL}${post.media_url}`)
      : null,
    gif: post.gif_url || null,
  }));
setPublicPosts(userPosts);
setPostCount(userPosts.length);
setMediaCount(userPosts.filter(p => p.media_url || p.gif).length);

// â¤ï¸ Liked posts
const likedRes = await fetch(`${process.env.REACT_APP_API_URL}/users/${username}/liked-posts`);
const likedPostsRaw = likedRes.ok ? await likedRes.json() : [];
const liked = likedPostsRaw.map(post => ({
  ...post,
  repliesCount: post.replies?.length || 0,
  repostsCount: Array.isArray(post.reposts) ? post.reposts.length : post.repost_count || 0,
  thumbnail: post.thumbnail?.startsWith("http")
    ? post.thumbnail
    : `${process.env.REACT_APP_API_URL}${post.thumbnail || "/images/default-thumbnail.jpg"}`,
  media_url: post.media_url
    ? (post.media_url.startsWith("http")
        ? post.media_url
        : post.media_url.startsWith("/backend/")
          ? `${process.env.REACT_APP_API_URL}${post.media_url.replace("/backend", "")}`
          : `${process.env.REACT_APP_API_URL}${post.media_url}`)
    : null,
  gif: post.gif_url || null,
}));
setPublicLikedPosts(liked);
setLikeCount(liked.length);

// ðŸ” Reposts
const repostRes = await fetch(`${process.env.REACT_APP_API_URL}/users/${username}/reposts`);
const repostedRaw = repostRes.ok ? await repostRes.json() : [];
const reposted = repostedRaw.map(post => ({
  ...post,
  repliesCount: post.repliesCount ?? (post.replies?.length || 0),
  repostsCount: post.repostsCount ?? (Array.isArray(post.reposts) ? post.reposts.length : 0),
  thumbnail: post.thumbnail?.startsWith("http")
    ? post.thumbnail
    : `${process.env.REACT_APP_API_URL}${post.thumbnail || "/images/default-thumbnail.jpg"}`,
  media_url: post.media_url
    ? (post.media_url.startsWith("http")
        ? post.media_url
        : post.media_url.startsWith("/backend/")
          ? `${process.env.REACT_APP_API_URL}${post.media_url.replace("/backend", "")}`
          : `${process.env.REACT_APP_API_URL}${post.media_url}`)
    : null,
  gif: post.gif_url || null,
}));
setPublicUserReposts(reposted);
setRepostCount(reposted.length);

// ðŸ’¬ Replies
const repliesRes = await fetch(`${process.env.REACT_APP_API_URL}/users/${username}/replies`);
const repliesRaw = repliesRes.ok ? await repliesRes.json() : [];

const replies = repliesRaw.map(reply => ({
  ...reply,
  repliesCount: reply.replies?.length || 0,
  repostsCount: Array.isArray(reply.reposts) ? reply.reposts.length : reply.repost_count || 0,
  thumbnail: reply.thumbnail?.startsWith("http")
    ? reply.thumbnail
    : `${process.env.REACT_APP_API_URL}${reply.thumbnail || "/images/default-thumbnail.jpg"}`,
  media_url: reply.media_url
    ? (reply.media_url.startsWith("http")
        ? reply.media_url
        : `${process.env.REACT_APP_API_URL}${reply.media_url}`)
    : null,
  gif: reply.gif_url || null,

  // âœ… Threading support
  originalPost: reply.originalPost || null,
  lineHeight: reply.lineHeight || 100, // fallback if not provided by backend
}));

setPublicUserReplies(replies);
setReplyCount(replies.length);



  } catch (error) {
    console.error("âŒ Error fetching public profile posts:", error);
  }
};

console.log("ðŸž publicUserReplies:", publicUserReplies);

  useEffect(() => {
    if (username) {
      fetchPublicProfilePosts(username);
    }
  }, [username]);




  useEffect(() => {
  const fetchUserData = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/profile/${username}`);
      if (!response.ok) throw new Error("User not found.");

      const userData = await response.json();
      setPublicUser(userData);

      // âœ… Load follower/following counts as soon as we have userData
      const followersRes = await axios.get(`${process.env.REACT_APP_API_URL}/api/followers/${userData.id}`);
      const followingRes = await axios.get(`${process.env.REACT_APP_API_URL}/api/following/${userData.id}`);

      setFollowerCount(Array.isArray(followersRes.data) ? followersRes.data.length : 0);
      setFollowingCount(Array.isArray(followingRes.data) ? followingRes.data.length : 0);

      // âœ… Now fetch posts for this user
      fetchUserPosts(userData.username);

      // âœ… Finally check if the logged-in user follows this public user
const currentUser = JSON.parse(localStorage.getItem("currentUser"));
if (currentUser && currentUser.id !== userData.id) {
  const checkFollow = await axios.get(
    `${process.env.REACT_APP_API_URL}/api/is-following`,
    {
      params: {
        followedId: userData.id,
      },
      withCredentials: true,
    }
  );
  setIsFollowing(checkFollow.data.isFollowing);
}

} catch (error) {
  console.error("âŒ Error fetching profile or follow data:", error);
}
};

  const fetchUserPosts = async (username) => {
  try {
    const response = await fetch(`${process.env.REACT_APP_API_URL}/posts`);
    if (!response.ok) throw new Error("Failed to fetch posts.");

    // â­ Fetch all posts
    let allPosts = await response.json();

    // â­ Sort newest â†’ oldest (global fix)
    allPosts = allPosts.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));

    // â­ Filter for only this profile's posts
    const filteredPosts = allPosts.filter((post) => post.username === username);

    setPosts(filteredPosts);
  } catch (error) {
    console.error("âŒ Error fetching posts:", error);
  }
};


  fetchUserData();
}, [username]);

// Measure reply connector lines only while the Replies tab is actually rendered.
useEffect(() => {
  if (
    publicFilterType !== "replies" ||
    !publicUserReplies ||
    publicUserReplies.length === 0
  ) {
    return;
  }

  let cancelled = false;
  let timeoutId = null;
  let attempts = 0;
  const maxAttempts = 10;

  const measure = () => {
    if (cancelled) return;

    const newHeights = {};
    Object.keys(originalRefs.current).forEach((id) => {
      const orig = originalRefs.current[id];
      const reply = replyRefs.current[id];
      if (orig && reply) {
        const top = orig.getBoundingClientRect().bottom + window.scrollY;
        const replyTop = reply.getBoundingClientRect().top + window.scrollY;
        newHeights[id] = replyTop - top;
      }
    });

    if (Object.keys(newHeights).length > 0) {
      setLineHeights(newHeights);
      return;
    }

    attempts += 1;
    if (attempts < maxAttempts) {
      timeoutId = window.setTimeout(measure, 100);
    }
  };

  measure();

  return () => {
    cancelled = true;
    if (timeoutId !== null) {
      window.clearTimeout(timeoutId);
    }
  };
}, [publicUserReplies, showPostModal, publicFilterType]);


const handleFollowToggle = async () => {
  const currentUser = JSON.parse(localStorage.getItem("currentUser"));
  if (!currentUser || !publicUser) return;

  setFollowLoading(true);
  try {
    // âœ… FIX: must match backend routes exactly
    const endpoint = isFollowing
      ? "/api/unfollow"
      : "/api/follow";

    const response = await axios.post(
      `${process.env.REACT_APP_API_URL}${endpoint}`,
      {
        followedId: publicUser.id,
      },
      {
        withCredentials: true,
      }
    );

    console.log("ðŸ”„ Toggle response:", response.data);

    // âœ… Immediate UI toggle
    setIsFollowing(!isFollowing);
    setFollowerCount((prev) => (isFollowing ? prev - 1 : prev + 1));

    // âœ… Refresh this public userâ€™s profile counts after toggle
    const updatedProfile = await fetch(
      `${process.env.REACT_APP_API_URL}/profile/${username}`
    );
    if (updatedProfile.ok) {
      const userData = await updatedProfile.json();
      setPublicUser(userData);

      // âœ… Re-fetch followers/following counts
      const followersRes = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/followers/${userData.id}`
      );
      const followingRes = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/following/${userData.id}`
      );
      setFollowerCount(
        Array.isArray(followersRes.data) ? followersRes.data.length : 0
      );
      setFollowingCount(
        Array.isArray(followingRes.data) ? followingRes.data.length : 0
      );
    }
  } catch (err) {
    console.error("âŒ Follow toggle failed:", err);
  }
  setFollowLoading(false);
};



const openUserList = async (type) => {
  try {
    const currentUser = JSON.parse(localStorage.getItem("currentUser"));
    if (!publicUser || !currentUser) return;

    // âœ… Fetch correct list (followers or following)
    const endpoint =
      type === "followers"
        ? `${process.env.REACT_APP_API_URL}/api/followers/${publicUser.id}`
        : `${process.env.REACT_APP_API_URL}/api/following/${publicUser.id}`;

    const response = await axios.get(endpoint);
    const fetchedList = response.data;

    // âœ… Get the viewerâ€™s own following list
    const viewerFollowsRes = await axios.get(
      `${process.env.REACT_APP_API_URL}/api/following/${currentUser.id}`
    );

    const viewerFollowingIds = viewerFollowsRes.data.map(u => u.id); // âœ… flat IDs

const updatedList = fetchedList.map((u) => {
  const alreadyFollowing = viewerFollowingIds.includes(u.id);
  return {
    ...u,
    isFollowing: alreadyFollowing,
  };
});

    setUserList(updatedList);
    setUserListType(type);
    setShowUserListModal(true);

    // âœ… Refresh counts directly
    if (type === "followers") {
      setFollowerCount(updatedList.length);
    } else {
      setFollowingCount(updatedList.length);
    }
  } catch (err) {
    console.error(`âŒ Failed to load ${type}:`, err);
  }
};

const handleUserFollowToggle = async (targetUserId, currentlyFollowing) => {
  const currentUser = JSON.parse(localStorage.getItem("currentUser"));
  if (!currentUser) return;

  console.log("ðŸ” Follow toggle clicked in modal:", {
    targetUserId,
    currentlyFollowing,
    loggedInUser: currentUser.id,
  });

  try {
    const endpoint = currentlyFollowing ? "/api/unfollow" : "/api/follow";

    await axios.post(
      `${process.env.REACT_APP_API_URL}${endpoint}`,
      {
        followedId: targetUserId,
      },
      {
        withCredentials: true,
      }
    );

    // âœ… Update modal list immediately with correct alias
    setUserList((prevList) =>
      prevList.map((entry) => {
        const userObj =
          userListType === "followers"
            ? entry.followerUser
            : entry.followedUser; // âœ… FIX alias

        if (!userObj) return entry;

        if (userObj.id === targetUserId) {
          return {
            ...entry,
            [userListType === "followers" ? "followerUser" : "followedUser"]: {
              ...userObj,
              isFollowing: !currentlyFollowing,
            },
          };
        }
        return entry;
      })
    );
  } catch (err) {
    console.error("âŒ Error toggling follow inside modal:", err);
  }
};



  if (!publicUser) return <p>Loading...</p>;

  const currentUser = JSON.parse(localStorage.getItem("currentUser"));

  const profileImage = publicUser.thumbnail?.startsWith("http")
  ? publicUser.thumbnail
  : publicUser.thumbnail?.startsWith("/images/")
    ? `${process.env.REACT_APP_PUBLIC_URL}${publicUser.thumbnail}`
    : publicUser.thumbnail
      ? `${process.env.REACT_APP_API_URL}/${publicUser.thumbnail}`
      : `${process.env.REACT_APP_PUBLIC_URL}/images/default-thumbnail.jpg`;

const profileBackground = publicUser.background?.startsWith("http")
  ? publicUser.background
  : publicUser.background?.startsWith("/images/")
    ? `${process.env.REACT_APP_PUBLIC_URL}${publicUser.background}`
    : publicUser.background
      ? `${process.env.REACT_APP_API_URL}/${publicUser.background}`
      : `${process.env.REACT_APP_PUBLIC_URL}/images/default-banner.jpg`;


  return (
    <div className="public-profile-page-container">
      <h1 className="public-profile-title">Public Profile</h1>

      <div className="public-profile-banner-wrapper">
        <div
          className="public-profile-banner"
          style={{ backgroundImage: `url("${profileBackground}")` }}
        ></div>

        <img
          src={profileImage}
          alt="Profile"
          className="public-profile-picture"
        />
      </div>

      {currentUser?.id !== publicUser.id && (
        <div className="public-follow-button-wrapper">
          <button onClick={handleFollowToggle} disabled={followLoading}>
            {followLoading
              ? "Processing..."
              : isFollowing
              ? "Unfollow"
              : "Follow"}
          </button>
        </div>
      )}

      <p className="public-profile-bio">{publicUser.bio || "No bio available."}</p>

      <div className="public-profile-follow-counts">
        <span onClick={() => openUserList("followers")} style={{ cursor: "pointer" }}>
          <strong>{followerCount}</strong> Followers
        </span>
        <span style={{ margin: "0 10px" }}>|</span>
        <span onClick={() => openUserList("following")} style={{ cursor: "pointer" }}>
          <strong>{followingCount}</strong> Following
        </span>
      </div>

      <section className="public-profile-posts">
        <div className="public-profile-name-block">
  <div
    style={{
      display: "flex",
      alignItems: "center",
      gap: "8px",
      flexWrap: "wrap",
    }}
  >
    <h2 className="public-profile-realname-header">
      {publicUser.name || publicUser.username}
    </h2>

    {publicUser.Group?.showBadge && (
      <span
        title={publicUser.Group?.badgeLabel}
        style={{
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          lineHeight: "1",
          position: "relative",
          top: "-1px",
        }}
      >
        {publicUser.Group?.badgeType === "circle" && (
          <span
            style={{
              width: "24px",
              height: "24px",
              borderRadius: "50%",
              backgroundColor: "#000",
              color: "#d4af37",
              fontSize: "13px",
              fontWeight: "bold",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {publicUser.Group?.badgeText}
          </span>
        )}

        {publicUser.Group?.badgeType === "star" && (
          <span
            style={{
              color:
                publicUser.Group?.badgeColor === "silver"
                  ? "#C0C0C0"
                  : publicUser.Group?.badgeColor === "gold"
                  ? "#FFD700"
                  : publicUser.Group?.badgeColor === "platinum"
                  ? "#b9c3cf"
                  : "#4da6ff",
              fontSize: "22px",
            }}
          >
            ★
          </span>
        )}

        {publicUser.Group?.badgeType === "diamond" && (
          <span
            style={{
              color: "#4fd1ff",
              fontSize: "20px",
            }}
          >
            ♦
          </span>
        )}
      </span>
    )}
  </div>

  <p className="public-profile-username-header">
    @{publicUser.username}
  </p>
</div>

{/* âœ… Action Bar with Counts */}
<div className="profile-action-bar">
  <button
    className={publicFilterType === "all" ? "active-filter" : ""}
    onClick={() => setPublicFilterType("all")}
  >
    Posts ({publicPosts.length})
  </button>

  <button
    className={publicFilterType === "likes" ? "active-filter" : ""}
    onClick={() => setPublicFilterType("likes")}
  >
    Likes ({publicLikedPosts.length})
  </button>

  <button
    className={publicFilterType === "replies" ? "active-filter" : ""}
    onClick={() => setPublicFilterType("replies")}
  >
    Replies ({publicUserReplies.length})
  </button>

  <button
    className={publicFilterType === "reposts" ? "active-filter" : ""}
    onClick={() => setPublicFilterType("reposts")}
  >
    Reposts ({publicUserReposts.length})
  </button>

  <button
    className={publicFilterType === "media" ? "active-filter" : ""}
    onClick={() => setPublicFilterType("media")}
  >
    Media ({publicPosts.filter((p) => p.media_url || p.gif).length})
  </button>
</div>

{/* âœ… Unified Filtered Rendering with PostItem + Threaded Replies */}
<section className="profile-page-posts">
  <h2>
    {publicFilterType === "all" && "Posts"}
    {publicFilterType === "likes" && "Liked Posts"}
    {publicFilterType === "replies" && "Replies"}
    {publicFilterType === "reposts" && "Reposts"}
    {publicFilterType === "media" && "Media"}
  </h2>

  {(() => {
    let filtered = [];

    if (publicFilterType === "all") filtered = publicPosts;
    if (publicFilterType === "likes") filtered = publicLikedPosts;
    if (publicFilterType === "replies") filtered = publicUserReplies;
    if (publicFilterType === "reposts") filtered = publicUserReposts;
    if (publicFilterType === "media") {
      filtered = publicPosts.filter((p) => p.media_url || p.gif);
    }

    if (publicFilterType === "replies") {
  return filtered.length > 0 ? (
    <div className="profile-replies-section">
      {filtered.map((reply) => (
        <div className="reply-wrapper" key={reply.id}>
          <div
            className="profile-page-post reply-combined-box"
            style={{ position: "relative" }}
          >
            {/* ðŸ”´ Connector Line */}
            {lineHeights[reply.id] && (
              <div
                style={{
                  position: "absolute",
                  top: "52px",
                  left: "33px",
                  width: "1px",
                  height: `${lineHeights[reply.id] - 5}px`,
                  backgroundColor: "#bbb",
                  zIndex: 0,
                }}
              ></div>
            )}

            {/* ðŸ”¹ Original Post */}
            <div className="profile-post-header">
              <img
  ref={(el) => {
    originalRefs.current[reply.id] = el;
    if (el) console.log("ðŸŸ¢ Original ref set:", reply.id);
  }}
  src={
    reply.originalPost?.thumbnail?.startsWith("http")
      ? reply.originalPost.thumbnail
      : `${process.env.REACT_APP_API_URL}${
          reply.originalPost?.thumbnail ||
          "/images/default-thumbnail.jpg"
        }`
  }
  alt="Original poster"
  className="profile-post-thumbnail"
/>

              <div className="profile-post-header-block">
                <div className="profile-post-header-line">
                  <span className="profile-post-realname">
                    {reply.originalPost?.postUser?.name ||
                      reply.originalPost?.name ||
                      "Unknown"}
                  </span>
                  <span className="profile-post-username">
                    @{reply.originalPost?.username || "unknown"}
                  </span>
                  <span className="profile-post-date">
  {reply.originalPost?.createdAt ? timeAgo(reply.originalPost.createdAt) : ""}
</span>

                </div>
                <p className="profile-post-text">
                  {reply.originalPost?.content.length > 300 ? (
                    <>
                      {reply.originalPost.content.slice(0, 300)}...
                      <button
                        className="show-more-btn"
                        onClick={() => {
                          setSelectedPost(reply.originalPost);
                          setShowPostModal(true);
                        }}
                      >
                        Show more
                      </button>
                    </>
                  ) : (
                    reply.originalPost?.content
                  )}
                </p>
              </div>
            </div>

            {reply.originalPost?.media_url &&
              (reply.originalPost.media_url.endsWith(".mp4") ? (
                <video
                  controls
                  className="profile-post-media"
                  src={`${process.env.REACT_APP_API_URL}${reply.originalPost.media_url}`}
                />
              ) : (
                <img
                  className="profile-post-media"
                  src={`${process.env.REACT_APP_API_URL}${reply.originalPost.media_url}`}
                  alt="Original post media"
                />
              ))}

            {reply.originalPost?.gif && (
              <img
                src={reply.originalPost.gif}
                className="profile-post-gif"
                alt="GIF"
              />
            )}

            {/* ðŸ”¹ Replying User */}
<div className="profile-post-header reply-spacing">
  <div
    ref={(el) => {
      replyRefs.current[reply.id] = el;
      if (el) console.log("ðŸ”µ Reply container ref set:", reply.id);
    }}
  >
    <img
      src={
        reply.thumbnail?.startsWith("http")
          ? reply.thumbnail
          : `${process.env.REACT_APP_API_URL}${
              reply.thumbnail || "/images/default-thumbnail.jpg"
            }`
      }
      alt="Reply user"
      className="profile-post-thumbnail"
    />
  </div>

  <div className="profile-post-header-block">
    <div className="profile-post-header-line">
      <span className="profile-post-realname">
        {reply.postUser?.name || reply.name || "Unknown"}
      </span>
      <span className="profile-post-username">@{reply.username}</span>
      <span className="profile-post-date">
  {timeAgo(reply.createdAt)}
</span>

    </div>
    <p className="profile-post-text">{reply.content}</p>
  </div>
</div>

{reply.gif && (
  <img
    src={reply.gif}
    className="profile-post-gif"
    alt="Reply GIF"
  />
)}

{reply.media_url &&
  (reply.media_url.endsWith(".mp4") ||
  reply.media_url.endsWith(".webm") ||
  reply.media_url.endsWith(".ogg") ? (
    <video controls className="profile-post-media">
      <source src={reply.media_url} />
      Your browser does not support the video tag.
    </video>
  ) : (
    <img
      src={reply.media_url}
      alt="Reply media"
      className="profile-post-media"
    />
  ))}

            {/* ðŸ”¹ Action Bar */}
            <div className="profile-post-actions">
              <button>{"\u2764"} {reply.likes || 0}</button>
              <button>{"\uD83D\uDD01"} {reply.repost_count || 0}</button>
              <button onClick={() => openReplyDialog(reply.id)}>{"\uD83D\uDCAC"} 0</button>

              <div
                className="post-dropdown"
                onMouseEnter={() => setDropdownOpen(reply.id)}
                onMouseLeave={() => setDropdownOpen(null)}
              >
                <button className="ellipsis-button">{"\u22EE"}</button>
                {dropdownOpen === reply.id && (
                  <div className="dropdown-menu">
                    <button onClick={() => handleDeletePost(reply.id)}>
                      {"\uD83D\uDDD1"} Delete
                    </button>
                    <button onClick={() => reportPost(reply.id)}>{"\uD83D\uDEA9"} Report</button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  ) : (
    <p>No replies yet.</p>
  );
}

    // âœ… Default rendering for all other tabs
    return filtered.length > 0 ? (
      filtered.map((post) => <PostItem key={post.id} post={post} />)
    ) : (
      <p>No {publicFilterType} yet.</p>
    );
  })()}
</section>




      </section>

      {showPostModal && selectedPost && (
        <PostDetailModal
          post={selectedPost}
          onClose={() => {
            setShowPostModal(false);
            setSelectedPost(null);
          }}
          onReply={() => alert("You must be logged in to reply.")}
          onLike={() => alert("You must be logged in to like posts.")}
          onRepost={() => alert("You must be logged in to repost.")}
          onNavigateToProfile={(username) => {
            window.location.href = `/@${username}`;
          }}
        />
      )}

      {/* ðŸ”µ FOLLOW LIST MODAL */}
      {/* ðŸ”µ FOLLOW LIST MODAL */}
{showUserListModal && (
  <div className="follow-modal-overlay">
    <div className="follow-modal">
      <h3>{userListType === "followers" ? "Followers" : "Following"}</h3>
      <button onClick={() => setShowUserListModal(false)} className="close-follow-modal">
        Close
      </button>
      <ul className="follow-user-list">
  {userList.map((user) => {
    // âœ… For followers, data is wrapped in followerUser; for following, itâ€™s a flat user
    // âœ… For followers, data is wrapped in followerUser; for following, itâ€™s wrapped in followingUser
const u =
  userListType === "followers"
    ? user.followerUser // alias for who follows this user
    : user.followingUser || user; // alias for who this user follows, fallback flat

if (!u) return null;

const thumbnail = u.thumbnail?.startsWith("http")
  ? u.thumbnail
  : `${process.env.REACT_APP_API_URL}${u.thumbnail || "/images/default-thumbnail.jpg"}`;

// âœ… Calculate follow status correctly
const isFollowing = u.isFollowing ?? false;

return (
  <li key={u.id} className="follow-user-item">
    <img
      src={thumbnail}
      alt={u.username}
      className="follow-user-thumbnail"
    />
    <div className="follow-user-details">
      <span className="follow-user-name">{u.name || "No name"}</span>
      <span className="follow-user-username">@{u.username}</span>
    </div>
    {currentUser?.id !== u.id && (
      <button
        className={`follow-user-action-button ${isFollowing ? "following" : ""}`}
        onClick={() => handleUserFollowToggle(u.id, isFollowing)}
        onMouseEnter={(e) => {
          if (isFollowing) e.target.textContent = "Unfollow";
        }}
        onMouseLeave={(e) => {
          if (isFollowing) e.target.textContent = "Following";
        }}
      >
        {isFollowing ? "Following" : "Follow"}
      </button>
    )}
  </li>
);


    return (
      <li key={u.id} className="follow-user-item">
        <img
          src={thumbnail}
          alt={u.username}
          className="follow-user-thumbnail"
        />
        <div className="follow-user-details">
          <span className="follow-user-name">{u.name || "No name"}</span>
          <span className="follow-user-username">@{u.username}</span>
        </div>
        {currentUser?.id !== u.id && (
          <button
            className={`follow-user-action-button ${u.isFollowing ? "following" : ""}`}
            onClick={() => handleUserFollowToggle(u.id, u.isFollowing)}
            onMouseEnter={(e) => {
              if (u.isFollowing) e.target.textContent = "Unfollow";
            }}
            onMouseLeave={(e) => {
              if (u.isFollowing) e.target.textContent = "Following";
            }}
          >
            {u.isFollowing ? "Following" : "Follow"}
          </button>
        )}
      </li>
    );
  })}
</ul>

    </div>
  </div>
)}

    </div>
  );
}

export default PublicProfile;
